import { CategoriesPage } from './_page'

/**
 * Инициализирует страницу категорий при наличии соответствующего контейнера в DOM.
 */
export function initCategoriesPage() {
  const pageElement = document.querySelector('[data-categories-page]')

  if (pageElement) {
    new CategoriesPage()
  }
}
